import React from "react";
import {
  StudentChart,
  InviteChart,
  DateRangePicker,
  SideMenu,
  BackHeader,
} from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
let TutorAnalytics = (props) => {
  const navigate = useNavigate();
  let TableData = [
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },

    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
    {
      date: "JAN 4, 2022",
      name: "Sallie Gulgowski",
      country: "burnside",
      cource: "2",
      price: "$200",
    },
  ];
  return (
    <SideMenu>
      <div className="page-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <div className="analytics-graph-main">
          <div className="graph-filter-main">
            <p className="analytics-graph-heading">
              how many classes are taught by this tutor
            </p>
            <div className="analytics-graph-filter-header">
              <p className="analytics-graph-header-date">Jan-2022</p>
              <select className="analytics-graph-filter-dropdown">
                <option value="Monthly">Monthly</option>
                <option value="Weekely">Weekely</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
          </div>
          <StudentChart />
        </div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={8} lg={12} md={12} sm={12} xs={12}>
              <div className="analytics-graph-main">
                <div className="graph-filter-main">
                  <p className="analytics-graph-heading">
                    how many people he invited to join the institute
                  </p>
                  <div className="analytics-graph-filter-header">
                    <p className="analytics-graph-header-date">Jan-2022</p>
                    <select className="analytics-graph-filter-dropdown">
                      <option value="Monthly">Monthly</option>
                      <option value="Weekely">Weekely</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>
                </div>
                <InviteChart />
              </div>
            </Grid>
            <Grid item xl={4} lg={12} md={12} sm={12} xs={12}>
              <div className="analytics-graph-main">
                <div className="graph-filter-main">
                  <p className="analytics-graph-heading">Wallet Earnings</p>
                  <div className="analytics-graph-filter-header">
                    <select className="analytics-graph-filter-dropdown">
                      <option value="Monthly">Monthly</option>
                      <option value="Weekely">Weekely</option>
                      <option value="Yearly">Yearly</option>
                    </select>
                  </div>
                </div>
                <InviteChart />
              </div>
            </Grid>
          </Grid>
        </Box>
        <br />
        <br />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by student name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by student name"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div>
                <p className="header-input-heading">Search by Country</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by Country"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={6} xs={12}>
              <div className="analytics-graph-header">
                <p className="analytics-graph-header-date">Jan-2022</p>
                <select className="analytics-graph-filter-dropdown">
                  <option value="Monthly">Monthly</option>
                  <option value="Weekely">Weekely</option>
                  <option value="Yearly">Yearly</option>
                </select>
              </div>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="analytics-tutors-table-date-heading">date</th>
                <th className="analytics-tutors-table-tutor-name-heading">
                  Tutor Name
                </th>
                <th className="analytics-tutors-table-branch-name-heading">
                  Branch Name
                </th>
                <th className="analytics-tutors-table-phone-number-heading">
                  Phone
                </th>
                <th className="analytics-tutors-table-role-heading">Role</th>
                <th className="analytics-tutors-table-email-heading">Email</th>
                <th className="analytics-tutors-table-status-heading">
                  Status
                </th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-date-data">{tableValue.date}</td>
                    <td className="table-data">Hishmat Rai</td>
                    <td className="table-data">Mithi Tharparkar, Sindh</td>
                    <td className="table-data">032323332</td>
                    <td className="table-data">Teacher</td>
                    <td className="table-email-data">WillowAnderson@Gmail.Com</td>
                    <td className="table-center-data">Active</td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default TutorAnalytics;
